<template>
  <vx-card no-shadow>

    <div class="vx-row">
      <div class="vx-col w-full">
        <h4>Factura Electrónica</h4>
      </div>
    </div>
   
    <!-- <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <h6>Condiguración de Moneda</h6>
      </div>
      <div class="vx-col w-full">
        <div class="vx-row flex justify-center py-3">
          <vs-input label-placeholder="Nombre" class="mr-3" v-model="monName"/>
          <vs-input label-placeholder="Símbolo" class="ml-3" v-model="monSym"/>
        </div>
      </div>
    </div> -->
        <vs-tabs position="left"> 
          <vs-tab label="Datos Generales"> 
              <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center" >
                <vs-input class="w-full px-5" label="Nombre Empresarial" placeholder=""
                name="empresarial" v-validate="'required'" v-model='facturacion.empresarial' />
                <span class="text-danger">{{ errors.first('new-patient.empresarial') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Afiliación" placeholder=""
                name="afiliacion" v-validate="'required'" v-model='facturacion.afiliacion' />
                <span class="text-danger">{{ errors.first('new-patient.afiliacion') }}</span>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Pais" placeholder=""
                name="pais" v-validate="'required|digits:8'" v-model='facturacion.pais'/>
                <span class="text-danger">{{ errors.first('new-patient.celular') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="NIT" placeholder="" 
                name="NIT" v-validate="''" v-model='facturacion.nit'/>
                <span class="text-danger">{{ errors.first('new-patient.NIT') }}</span>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Requestor" placeholder=""
                name="requestor" v-validate="'required|email'" v-model='facturacion.requestor'/>
                <span class="text-danger">{{ errors.first('new-patient.requestor') }}</span>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="User" placeholder=""
                name="user" v-validate="'required'" v-model='facturacion.user'/>
                <span class="text-danger">{{ errors.first('new-patient.user') }}</span>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Email" placeholder=""
                name="email" v-validate="'required|digits:8'" v-model='facturacion.email'/>
                <span class="text-danger">{{ errors.first('new-patient.celular') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Username" placeholder="" 
                name="username" v-validate="''" v-model='facturacion.username'/>
                <span class="text-danger">{{ errors.first('new-patient.username') }}</span>
              </div>
            </div>
            <vs-divider class="mt-6 mb-5" />
            <div class="vx-row pt-3 pb-6">
              <div class="vx-col w-full flex justify-center">
                <vs-button icon-pack="feather" icon="icon-file-text" class="mr-4" color="primary" type="filled" 
                 @click="updateFacturacion">
                  Guardar
                </vs-button>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Generar Factura"> 
            <div class="vx-row mb-2">
              <div class="vx-col md:w-2/5 sm:w-full w-full flex flex-col items-center" >
                <vs-input class="w-full px-5" label="Nombre" placeholder=""
                name="name" v-validate="'required'" v-model='factData.receptor.nombre' />
                <span class="text-danger">{{ errors.first('new-patient.name') }}</span>
              </div>
              <div class="vx-col md:w-2/5 sm:w-full w-full flex flex-col items-center inline">
                <vs-input class="vx-col inline w-full pl-3 mr-3" label="NIT" placeholder=""
                name="nit" v-validate="'required'" v-model='factData.receptor.id_receptor' />
                <span class="text-danger">{{ errors.first('new-patient.nit') }}</span>
              </div>
              <div class="vx-col md:w-1/5 sm:w-full w-full flex flex-col items-center inline">
                <vs-button class="mr-24 mt-6 inline" color="primary" type="filled" 
                 @click="validateNit">
                  Validar
                </vs-button>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Correo Electrónico" placeholder=""
                name="email" v-validate="'required'" v-model='factData.receptor.correo'/>
                <span class="text-danger">{{ errors.first('new-patient.email') }}</span>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Dirección" placeholder=""
                name="direccion" v-validate="'required'" v-model='factData.receptor.direccion'/>
                <span class="text-danger">{{ errors.first('new-patient.direccion') }}</span>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Total de Factura" placeholder=""
                name="total" v-validate="'required'" v-model='factData.items[0].precio'/>
                <span class="text-danger">{{ errors.first('new-patient.total') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <v-select class="w-full px-5 mt-6"  placeholder="Motivo" 
                name="motivo" :options='["Servicios Profesionales Médicos", "Otros"]' v-validate="''" v-model='factData.items[0].descripcion'/>
                <span class="text-danger">{{ errors.first('new-patient.motivo') }}</span>
              </div>
            </div>
            <vs-divider class="mt-6 mb-5" />
            <div class="vx-row pt-3 pb-6">
              <div class="vx-col w-full flex justify-center">
                <vs-button icon-pack="feather" icon="icon-file-text" class="mr-4" color="primary" type="filled" 
                 @click="generateFact">
                  Generar Factura
                </vs-button>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Anular Factura"> 
              <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center" >
                <vs-input class="w-full px-5" label="NIT Emisor" placeholder=""
                name="nite" v-validate="'required'" v-model='anulacion.anulacion.nitEmisor' />
                <span class="text-danger">{{ errors.first('new-patient.nite') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="NIT Receptor" placeholder=""
                name="nitr" v-validate="'required'" v-model='anulacion.anulacion.nitReceptor' />
                <span class="text-danger">{{ errors.first('new-patient.nitr') }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <v-select class="w-full px-5 mt-6"  placeholder="Motivo" 
                name="motivo" :options='["Otros"]' v-validate="''" v-model='anulacion.anulacion.motivoAnulacion'/>
                <span class="text-danger">{{ errors.first('new-patient.motivo') }}</span>
              </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Número de Documento" placeholder=""
                name="asg" v-validate="'required'" v-model='anulacion.anulacion.numeroDocumento'/>
                <span class="text-danger">{{ errors.first('new-patient.asg') }}</span>
              </div>
            </div>
            <vs-divider class="mt-6 mb-5" />
            <div class="vx-row pt-3 pb-6">
              <div class="vx-col w-full flex justify-center">
                <vs-button class="mr-4" color="primary" type="filled" 
                 @click="annulFact">
                  Emitir Anulación
                </vs-button>
              </div>
            </div>

          </vs-tab>
          <!--
          <vs-tab label="Nota de Crédito"> 
            <div class="vx-row mb-2">
              <div class="vx-col md:w-2/5 sm:w-full w-full flex flex-col items-center" >
                <vs-input class="w-full px-5" label="Nombre" placeholder=""
                name="name" v-validate="'required'" v-model='factData.receptor.nombre' />
                <span class="text-danger">{{ errors.first('new-patient.name') }}</span>
              </div>
              <div class="vx-col md:w-2/5 sm:w-full w-full flex flex-col items-center inline">
                <vs-input class="vx-col inline w-full pl-3 mr-3" label="NIT" placeholder=""
                name="nit" v-validate="'required'" v-model='factData.receptor.id_receptor' />
                <span class="text-danger">{{ errors.first('new-patient.nit') }}</span>
              </div>
              <div class="vx-col md:w-1/5 sm:w-full w-full flex flex-col items-center inline">
                <vs-button class="mr-24 mt-6 inline" color="primary" type="filled" 
                 @click="validateNit">
                  Validar
                </vs-button>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Departamento" placeholder=""
                name="depto" v-validate="'required'" v-model='factData.receptor.departamento'/>
                <span class="text-danger">{{ errors.first('new-patient.depto') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Municipio" placeholder="" 
                name="municipio" v-validate="''" v-model='factData.receptor.municipio'/>
                <span class="text-danger">{{ errors.first('new-patient.municipio') }}</span>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Correo Electrónico" placeholder=""
                name="email" v-validate="'required'" v-model='factData.receptor.correo'/>
                <span class="text-danger">{{ errors.first('new-patient.email') }}</span>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Dirección" placeholder=""
                name="direccion" v-validate="'required'" v-model='factData.receptor.direccion'/>
                <span class="text-danger">{{ errors.first('new-patient.direccion') }}</span>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Total de Factura" placeholder=""
                name="total" v-validate="'required'" v-model='factData.items[0].precio'/>
                <span class="text-danger">{{ errors.first('new-patient.total') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <v-select class="w-full px-5 mt-6"  placeholder="Motivo" 
                name="motivo" :options='["Servicios Profesionales Médicos", "Otros"]' v-validate="''" v-model='factData.items[0].descripcion'/>
                <span class="text-danger">{{ errors.first('new-patient.motivo') }}</span>
              </div>
            </div>
            <vs-divider class="mt-6 mb-5" />
            <div class="vx-row pt-3 pb-6">
              <div class="vx-col w-full flex justify-center">
                <vs-button class="mr-4" color="primary" type="filled" 
                 @click="generateCredit">
                  Emitir Nota de Crédito
                </vs-button>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Nota de Débito"> 
            <div class="vx-row mb-2">
              <div class="vx-col md:w-2/5 sm:w-full w-full flex flex-col items-center" >
                <vs-input class="w-full px-5" label="Nombre" placeholder=""
                name="name" v-validate="'required'" v-model='factData.receptor.nombre' />
                <span class="text-danger">{{ errors.first('new-patient.name') }}</span>
              </div>
              <div class="vx-col md:w-2/5 sm:w-full w-full flex flex-col items-center inline">
                <vs-input class="vx-col inline w-full pl-3 mr-3" label="NIT" placeholder=""
                name="nit" v-validate="'required'" v-model='factData.receptor.id_receptor' />
                <span class="text-danger">{{ errors.first('new-patient.nit') }}</span>
              </div>
              <div class="vx-col md:w-1/5 sm:w-full w-full flex flex-col items-center inline">
                <vs-button class="mr-24 mt-6 inline" color="primary" type="filled" 
                 @click="validateNit">
                  Validar
                </vs-button>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Departamento" placeholder=""
                name="depto" v-validate="'required'" v-model='factData.receptor.departamento'/>
                <span class="text-danger">{{ errors.first('new-patient.depto') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Municipio" placeholder="" 
                name="municipio" v-validate="''" v-model='factData.receptor.municipio'/>
                <span class="text-danger">{{ errors.first('new-patient.municipio') }}</span>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Correo Electrónico" placeholder=""
                name="email" v-validate="'required'" v-model='factData.receptor.correo'/>
                <span class="text-danger">{{ errors.first('new-patient.email') }}</span>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Dirección" placeholder=""
                name="direccion" v-validate="'required'" v-model='factData.receptor.direccion'/>
                <span class="text-danger">{{ errors.first('new-patient.direccion') }}</span>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Total de Factura" placeholder=""
                name="total" v-validate="'required'" v-model='factData.items[0].precio'/>
                <span class="text-danger">{{ errors.first('new-patient.total') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <v-select class="w-full px-5 mt-6"  placeholder="Motivo" 
                name="motivo" :options='["Servicios Profesionales Médicos", "Otros"]' v-validate="''" v-model='factData.items[0].descripcion'/>
                <span class="text-danger">{{ errors.first('new-patient.motivo') }}</span>
              </div>
            </div>
            <vs-divider class="mt-6 mb-5" />
            <div class="vx-row pt-3 pb-6">
              <div class="vx-col w-full flex justify-center">
                <vs-button class="mr-4" color="primary" type="filled" 
                 @click="generateDebit">
                  Emitir Nota de Débito
                </vs-button>
              </div>
            </div>
          </vs-tab>
          -->
        </vs-tabs>
        <modal
                    name="factura"
                    height="auto"
                    width="50%"
                    style="z-index: 1001;"
                  >
                    <div class="p-4">
                      <div class="vx-row ">
                        <div class="mb-4 vx-col w-full flex flex-col text-center">
                          <h3>Factura Generada Éxitosamente</h3>
                        </div>
                        <div class="mb-4 mt-5  vx-col w-full flex flex-col items-center">
                          <vs-button  class="w-1/2" color="primary" type="filled" icon="dashboard" @click="openFact(html)">Ver Factura</vs-button>
                        </div>
                      </div>
                    </div>
                  </modal>
                  <modal
                    name="anulada"
                    height="auto"
                    width="50%"
                    style="z-index: 1001;"
                  >
                    <div class="p-4">
                      <div class="vx-row ">
                        <div class="mb-4 vx-col w-full flex flex-col text-center">
                          <h3>Factura Anulada Éxitosamente</h3>
                        </div>
                        <div class="mb-4 mt-5  vx-col w-full flex flex-col items-center">
                          <vs-button class="w-1/2" color="primary" type="filled" icon="dashboard" @click="cerrar()">Cerrar</vs-button>
                        </div>
                      </div>
                    </div>
                  </modal>
    

            
    <!-- Save & Reset Button -->

  </vx-card>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data () {
    return {
      monName: 'Quetzales',
      monSym: 'Q',
      defaultPrice: null,
      defaulIVA: 12,
      editting: false,
      userData: {},
      isSecretary: false,
      activeDoctorData: null,
      facturacion: {
        empresarial: null,
        afiliacion: null,
        pais: null,
        nit: null,
        email: null,
        username: null,
        user: null,
        requestor: null
      },
      html: null,
      factData: {
        "emisor": {
          "afiliacion": null,
          "cod_establecimiento": 1,
          "cod_postal": "01001",
          "correo": null,
          "departamento": null,
          "municipio": null,
          "direccion": "CIUDAD",
          "nit": null,
          "nombre_com": null,
          "nombre_em": null,
          "pais": null,
          "requestor": null,
          "user": null,
          "username": null,
        },
        "general": {
          "moneda": "GTQ",
          "tipo": "FACT",
          "fecha_hora_emision": null, // toISOString()
        },
        "receptor": {
          "cod_postal": "01001",
          "correo": null,
          "departamento": null,
          "municipio": null,
          "direccion": "CIUDAD",
          "id_receptor": null, // NIT
          "nombre": null,
          "pais": "GT"
          },
        "items": [
        {
            "BoS": "B",
            "cantidad": 1,
            "descripcion": null,
            "descuento": 0,
            "descuentoPorcentual": 0,
            "precio": null,
            "precio_unitario": null,
            "unidad_medida": "UND"
        }
        ]
      }, 
      factDataDef: {
        "emisor": {
          "afiliacion": null,
          "cod_establecimiento": 1,
          "cod_postal": null,
          "correo": null,
          "departamento": null,
          "municipio": null,
          "direccion": null,
          "nit": null,
          "nombre_com": null,
          "nombre_em": null,
          "pais": null,
          "requestor": null,
          "user": null,
          "username": null,
        },
        "general": {
          "moneda": "GTQ",
          "tipo": "FACT",
          "fecha_hora_emision": null, // toISOString()
        },
        "receptor": {
          "cod_postal": "01001",
          "correo": null,
          "departamento": null,
          "municipio": null,
          "direccion": "CIUDAD",
          "id_receptor": null, // NIT
          "nombre": null,
          "pais": "GT"
          },
        "items": [
        {
            "BoS": "B",
            "cantidad": 1,
            "descripcion": null,
            "descuento": null,
            "descuentoPorcentual": null,
            "precio": null,
            "precio_unitario": null,
            "unidad_medida": "UND"
        }
        ]
      },
      anulacion: {
        "emisor": {
          "afiliacion": null,
          "cod_establecimiento": 1,
          "cod_postal": "01001",
          "correo": null,
          "departamento": null,
          "municipio": null,
          "direccion": "CIUDAD",
          "nit": null,
          "nombre_com": null,
          "nombre_em": null,
          "pais": null,
          "requestor": null,
          "user": null,
          "username": null,
        },
        "anulacion": {
        "nitEmisor": null,
        "nitReceptor": null,
        "numeroDocumento": null,
        "fechaHoraEmision": null,
        "motivoAnulacion": null
        }
      }
    }
  },
  methods: {
    showAlert(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
    cerrar() {
      this.$modal.hide("anulada")
    },
    validateNit() {
      this.$store.dispatch('validateNit', this.factData.receptor.id_receptor).then(response=>{
         this.factData.receptor.nombre = response.data.nombre.nombreCompletoRegistrado
         this.showAlert(
            "success",
            "Nit Validado",
            ("Nombre Registrado: " + response.data.nombre.nombreCompletoRegistrado) 
          );
      }, error => {
        console.log (error)
        this.showAlert(
          "warning",
          "Error al validar NIT",
          "Porfavor revisar el NIT"
        )

      });
    },
    updateFacturacion(){
      const metaUpdateUser = {
        id: this.userData.id,
        meta: {...this.userData.meta, ...{'datosFacturacion': this.facturacion}}
      };
      this.$store.dispatch('evolugy/updateUser', metaUpdateUser);
      this.editting = false;

      this.showAlert(
            "success",
            "Datos de Facturación",
            "Datos de facturación actualizados exitosamente!"
          );
    },
    generateFact () {
      this.factData.emisor.nombre_em = this.activeUserInfo.meta.datosFacturacion.empresarial
      this.factData.emisor.nombre_com = this.activeUserInfo.meta.datosFacturacion.empresarial
      this.factData.emisor.afiliacion = this.activeUserInfo.meta.datosFacturacion.afiliacion
      this.factData.emisor.pais = this.activeUserInfo.meta.datosFacturacion.pais
      this.factData.emisor.correo = this.activeUserInfo.meta.datosFacturacion.email
      this.factData.emisor.username = this.activeUserInfo.meta.datosFacturacion.username
      this.factData.emisor.requestor = this.activeUserInfo.meta.datosFacturacion.requestor
      this.factData.emisor.user = this.activeUserInfo.meta.datosFacturacion.user
      this.factData.emisor.nit = this.activeUserInfo.meta.datosFacturacion.nit
      this.factData.emisor.municipio = "Guatemala"
      this.factData.emisor.departamento = "Guatemala"
      this.factData.items[0].precio_unitario = this.factData.items[0].precio
      console.log(this.factData)
      this.$vs.loading()
      this.$store.dispatch('generateReceipt', this.factData).then((response2) => {
          this.showAlert('success', 'Factura Generada Exitosamente', )
          this.html = response2.data.emailhtmlTemplate;
          this.$vs.loading.close()
          this.$modal.show("factura")
          error => {
        console.log(error)
        this.showAlert('danger', 'Error al generar factura', 'Revisar Datos Ingresados')
        this.$vs.loading.close();
          }
          
      });
    },
    generateCredit () {
      this.factData.emisor.nombre_em = this.activeUserInfo.meta.datosFacturacion.empresarial
      this.factData.emisor.nombre_com = this.activeUserInfo.meta.datosFacturacion.empresarial
      this.factData.emisor.afiliacion = this.activeUserInfo.meta.datosFacturacion.afiliacion
      this.factData.emisor.pais = this.activeUserInfo.meta.datosFacturacion.pais
      this.factData.emisor.correo = this.activeUserInfo.meta.datosFacturacion.email
      this.factData.emisor.username = this.activeUserInfo.meta.datosFacturacion.username
      this.factData.emisor.requestor = this.activeUserInfo.meta.datosFacturacion.requestor
      this.factData.emisor.user = this.activeUserInfo.meta.datosFacturacion.user
      this.factData.emisor.nit = this.activeUserInfo.meta.datosFacturacion.nit
      this.factData.emisor.municipio = "Guatemala"
      this.factData.emisor.departamento = "Guatemala"
      this.factData.general.tipo = "NCRE"
      this.factData.items[0].precio_unitario = this.factData.items[0].precio
      console.log(this.factData)
      this.$store.dispatch('generateReceipt', this.factData);
      
    },
    generateDebit () {
      this.factData.emisor.nombre_em = this.activeUserInfo.meta.datosFacturacion.empresarial
      this.factData.emisor.nombre_com = this.activeUserInfo.meta.datosFacturacion.empresarial
      this.factData.emisor.afiliacion = this.activeUserInfo.meta.datosFacturacion.afiliacion
      this.factData.emisor.pais = this.activeUserInfo.meta.datosFacturacion.pais
      this.factData.emisor.correo = this.activeUserInfo.meta.datosFacturacion.email
      this.factData.emisor.username = this.activeUserInfo.meta.datosFacturacion.username
      this.factData.emisor.requestor = this.activeUserInfo.meta.datosFacturacion.requestor
      this.factData.emisor.user = this.activeUserInfo.meta.datosFacturacion.user
      this.factData.emisor.nit = this.activeUserInfo.meta.datosFacturacion.nit
      this.factData.emisor.municipio = "Guatemala"
      this.factData.emisor.departamento = "Guatemala"
      this.factData.general.tipo = "NDEB"
      this.factData.items[0].precio_unitario = this.factData.items[0].precio
      console.log(this.factData)
      this.$store.dispatch('generateReceipt', this.factData);
    },
  annulFact() {
      this.anulacion.emisor.nombre_em = this.activeUserInfo.meta.datosFacturacion.empresarial
      this.anulacion.emisor.nombre_com = this.activeUserInfo.meta.datosFacturacion.empresarial
      this.anulacion.emisor.afiliacion = this.activeUserInfo.meta.datosFacturacion.afiliacion
      this.anulacion.emisor.pais = this.activeUserInfo.meta.datosFacturacion.pais
      this.anulacion.emisor.correo = this.activeUserInfo.meta.datosFacturacion.email
      this.anulacion.emisor.username = this.activeUserInfo.meta.datosFacturacion.username
      this.anulacion.emisor.requestor = this.activeUserInfo.meta.datosFacturacion.requestor
      this.anulacion.emisor.user = this.activeUserInfo.meta.datosFacturacion.user
      this.anulacion.emisor.nit = this.activeUserInfo.meta.datosFacturacion.nit
      this.anulacion.emisor.municipio = "Guatemala"
      this.anulacion.emisor.departamento = "Guatemala"
      this.anulacion.anulacion.fechaHoraEmision = new Date(Date.now()).toISOString()
      
      this.$vs.loading()
      this.$store.dispatch('generateAnul', this.anulacion).then((response2) => {
          this.showAlert('success', 'Factura Anulada Exitosamente', )
          this.$vs.loading.close();
          this.$modal.show("anulada")
      }, error => {
        console.log(error)
        this.showAlert('danger', 'Error al anular factura', 'Revisar Datos Ingresados')
        this.$vs.loading.close();
      });
  }, 
  openLoading(){
      
      setTimeout( ()=> {
        this.showAlert(
          "success",
          "Factura Generada Exitosamente",
          ""
        )
        
      }, 4000);
    },
    openFact(html) {
      var win = window.open("", "_blank",);
      win.document.body.innerHTML = html
    },
  },
  
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  beforeMount(){
    this.facturacion.empresarial = this.activeUserInfo.meta.datosFacturacion.empresarial
    this.facturacion.afiliacion = this.activeUserInfo.meta.datosFacturacion.afiliacion
    this.facturacion.pais = this.activeUserInfo.meta.datosFacturacion.pais
    this.facturacion.email = this.activeUserInfo.meta.datosFacturacion.email
    this.facturacion.username = this.activeUserInfo.meta.datosFacturacion.username
    this.facturacion.requestor = this.activeUserInfo.meta.datosFacturacion.requestor
    this.facturacion.user = this.activeUserInfo.meta.datosFacturacion.user
    this.facturacion.nit = this.activeUserInfo.meta.datosFacturacion.nit
    this.anulacion.anulacion.nitEmisor = this.activeUserInfo.meta.datosFacturacion.nit
    if(this.activeUserInfo.role !== "doctor" ){
    console.log('Es SECRE');
      this.isSecretary = true;
      this.$store.dispatch('getDoctorDataById', sessionStorage.getItem('activeDoctorId')).then(response=>{
        console.log('DOCTOR: ',response);
        this.activeDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
        
        if(this.activeDoctorData.meta && this.activeDoctorData.meta.defaultPrice){
           this.defaultPrice = this.activeDoctorData.meta.defaultPrice;
          this.defaultPrice = parseFloat(this.defaultPrice).toFixed(2);
        } else {
          if(this.activeUserInfo.meta.defaultPrice){
            this.defaultPrice = parseFloat(this.activeUserInfo.meta.defaultPrice).toFixed(2);
          } else {
            this.defaultPrice = 250.00;
          }
          
        }
       
      }, error => {
        console.error(error);
      });
    } else {
      this.isSecretary = false;
    }
  },
  mounted(){
    
  },
  beforeCreate(){
     this.userData = JSON.parse(JSON.stringify(this.$store.state.AppActiveUser))
  },
  created() {
     
  },
  
}
</script>
